/**
 * 模板市场-筛选条件组件
 * @author VenDream
 * @since 18/04/17
 */
import debounce from '@fe/common/lib/debounce';
import * as qs from '@fe/common/lib/query-string';
import Stat from '@fe/common/lib/stat';
import classnames from 'classnames';
import ColorSelector from 'components/color-selector';
import DropDown from 'components/dropdown';
import SortSwitch from 'components/sort-switch';
import STAT_PARAMS from 'constants/stat-params.json5';
import VARIABLES from 'constants/variable.json5';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { sendStat, updateSearchUrlFilterData } from 'utils/common';
import { isRabbitpreEnv } from 'utils/env';
import { pushFiboTemplateFilter } from 'utils/statisticSDK';
import { showRabbitBrandInfo } from 'utils/user';
import StoreFiltersOpenZone from 'components/store-filters-openzone';
import StoreFiltersOrgZone from 'components/store-filters-orgzone';
import './store-filters.less';

// 默认的当行高度
const ONE_LINE_HEIGHT = '43px';
class StoreFilters extends Component {
  static propTypes = {
    user: PropTypes.object,
    category: PropTypes.string,
    filters: PropTypes.array,
    isSearchType: PropTypes.bool,
    submitFilters: PropTypes.object,
    getStoreFilters: PropTypes.func,
    openZoneFilters: PropTypes.object,
    getOpenZoneFilters: PropTypes.func,
    openSearchFilters: PropTypes.object,
    orgZoneFilters: PropTypes.array,
    getOrgZoneFilters: PropTypes.func,
    setOrgZoneSearchFilters: PropTypes.func,
    orgZoneSearchFilters: PropTypes.object,
    setOpenSearchFilters: PropTypes.func,
    setSubmitFilters: PropTypes.func,
    clearSubmitFilters: PropTypes.func,
    clearFilter: PropTypes.func,
    addFilter: PropTypes.func,
    clearSingleSubmitFilters: PropTypes.func,
  };

  constructor() {
    super();
    // 角注
    this.corner = {
      award: VARIABLES.CORNER_SELECT.ALL,
      recommend: VARIABLES.CORNER_SELECT.ALL,
    };
    this.updateFolderBtnByResizing = debounce(
      this.updateFolderBtn.bind(this, 'resize'),
      100
    );
    this.updateSubmitFilters = this.updateSubmitFilters.bind(this);
    this.state = {
      reRender: false,
    };
  }

  componentDidMount() {
    //已收藏模板，过滤条件前端写死
    // 获取模板筛选项
    this.getFilterListApi();

    // 调整屏幕大小时，`更多`按钮进行适配
    window.addEventListener('resize', this.updateFolderBtnByResizing);

    this.setState({
      reRender: true,
    });
  }

  componentWillReceiveProps(nextProps) {
    // 切换Tab时，清空原有筛选条件组合
    if (nextProps.category !== this.props.category) {
      this.props.clearSubmitFilters();
      this.corner = {};
      // 首次切换Tab时，加载筛选项数据
      if (!nextProps.filters.length) {
        this.props.getStoreFilters(nextProps.category);
      }
    }
    // 清空角注原有筛选条件
    if (
      !nextProps.submitFilters.tplCornerLabel &&
      !nextProps.submitFilters.tplTop10 &&
      this.corner
    ) {
      this.corner = {};
    }
  }

  componentDidUpdate(prevProps) {
    // 企业专区下userInfo更新后携带orgId请求filter数据
    if (
      prevProps.user.organizeId !== this.props.user.organizeId &&
      this.props.category === VARIABLES.ENTERPRISE
    ) {
      this.getFilterListApi();
    }
    // 切换tab后同步更新折叠状态
    if (
      prevProps.category !== this.props.category ||
      prevProps.filters.length !== this.props.filters.length
    ) {
      this.updateFolderBtn();
      // 如果路径带参数查询对应分类列表
      this.getQueryParamsFilter();
    }
    if (
      this.props.category === 'CHAJIAN' &&
      prevProps.filters.length !== this.props.filters.length &&
      this.state.reRender
    ) {
      //如果是由券列表跳转过来，并且是玩法模板券，则要定位到玩法模板三级菜单
      let rank = window.location.search;
      if (rank.includes('?rank=')) {
        rank = rank.split('rank=')[1].split('&')[0];
      }
      const filterList = document.querySelectorAll('.sub-filter');
      for (const filter of filterList) {
        if (filter.classList.contains('active')) {
          filter.classList.remove('active');
        }
        if (filter.getAttribute('data-value') === rank) {
          let type = filter.getAttribute('data-type');
          let name = filter.getAttribute('data-showName');
          let key = filter.getAttribute('data-key');
          let value = filter.getAttribute('data-value');
          let text = filter.getAttribute('data-text');
          filter.classList.add('active');
          this.handleUpdateSubmitFilters.call(
            this,
            type,
            name,
            key,
            value,
            text
          );
          this.setState({
            reRender: false,
          });
          break;
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateFolderBtnByResizing);
  }

  // 获取模板筛选项
  getFilterListApi() {
    const {
      user,
      category,
      getOpenZoneFilters,
      getOrgZoneFilters,
      getStoreFilters,
    } = this.props;
    const { organizeId: orgId } = user || {};
    category === VARIABLES.OPENZONE
      ? getOpenZoneFilters()
      : category === VARIABLES.ENTERPRISE
      ? orgId && getOrgZoneFilters(orgId)
      : getStoreFilters(category);
  }

  // 渲染筛选条件
  getFilters() {
    const { category, filters } = this.props;
    const htmls = [];
    // 无筛选条件时不渲染
    !filters.length && null;
    for (const filter of filters) {
      const { showType, type, key, name, subFilters } = filter;
      let selectType = showType === 1 ? 'selection' : '';
      const cls = classnames({
        filter: 1,
        [`${selectType}-filter`]: selectType,
        folding: 1,
      });
      htmls.push(
        <li className={cls} key={`${category}_${name}`}>
          <span className="filter-title">{name}</span>
          <ul className="sub-filters-list" data-key={key}>
            {this.getSubFilters(name, showType, type, key, subFilters)}
          </ul>
          <span className="fold-btn" onClick={this.handleFolderList}>
            <span className="fold-text">更多</span>
            <span className="down-arrow" />
          </span>
        </li>
      );
    }

    return htmls;
  }

  // 渲染子筛选条件
  getSubFilters = (showName, showType, type, key, subFilters) => {
    const htmls = [];
    const { category } = this.props;
    // 普通文本项
    if (showType === 0) {
      for (const [i, item] of Object.entries(subFilters)) {
        const isAllItem = key === 'tplSpecies' && item.text === '全部';
        const isVideoItem = key === 'tplSpecies' && item.text === '视频';
        const cls = classnames({
          'sub-filter': true,
          active: ~~i === 0,
          'all-item': isAllItem,
          'video-item': isVideoItem,
        });
        // 如果是第三方合作平台 不展示视频筛选项
        if (!isRabbitpreEnv() && item.text === '视频') {
          continue;
        }
        htmls.push(
          <li
            className={cls}
            key={`${category}_${i}`}
            data-value={item.value}
            data-type={type}
            data-showName={showName}
            data-key={key}
            data-text={item.text}>
            <div
              className="normal-item"
              onClick={e =>
                this.handleUpdateSubmitFilters.call(
                  this,
                  type,
                  showName,
                  key,
                  item.value,
                  item.text,
                  e
                )
              }>
              {item.text}
            </div>
          </li>
        );
      }
      // 下拉选择项
    } else if (showType === 1) {
      for (const [i, filter] of Object.entries(subFilters)) {
        if (filter.children) {
          htmls.push(
            <li className="sub-filter" key={i}>
              {this.getSelectionFilter(filter)}
            </li>
          );
        }
      }
    }

    return htmls;
  };

  // 过滤空值查询项
  handleFilterSearchField(searchFields) {
    const form = {};
    Object.keys(searchFields).forEach(key => {
      if (searchFields[key]) {
        form[key] = searchFields[key];
      }
    });
    return form;
  }

  // 选择角标查询
  handleCornerSearch = (type, key, value, name, text) => {
    // let val = '';
    if (name === VARIABLES.CORNER_TITLE.AWARD) {
      this.corner = {
        ...this.corner,
        award: value,
      };
    } else {
      this.corner = {
        ...this.corner,
        recommend: value,
      };
    }
    // const form = this.handleFilterSearchField(this.corner);
    // val = Object.values(form).join(',');
    this.handleUpdateSubmitFilters.call(this, type, name, key, value, text);
  };

  // 渲染下拉筛选项
  getSelectionFilter = filter => {
    const { submitFilters } = this.props;
    const { fieldKey, type, showName, children } = filter;

    let items =
      children &&
      children.map(ele => {
        return { value: ele.fieldKey, text: ele.name };
      });
    items && items.unshift({ value: 'ALL', text: '全部' });
    const targetKey =
      submitFilters[fieldKey] && submitFilters[fieldKey].thirdFieldKey;
    const idx = this.getSelectionIdx(items, targetKey);

    if (fieldKey === 'tplColor') {
      items =
        children &&
        children.map(ele => {
          return {
            value: ele.fieldKey,
            color: '#' + ele.remark,
            text: ele.name,
          };
        });
      items && items.unshift({ value: 'ALL', text: '全部' });

      return (
        (items && (
          <div className="color-item">
            <span className="label">{showName}</span>
            <ColorSelector
              selected={idx || 0}
              items={items}
              onSelected={(idx, value, text) =>
                this.handleUpdateSubmitFilters.call(
                  this,
                  type,
                  showName,
                  fieldKey,
                  value,
                  text
                )
              }
            />
          </div>
        )) ||
        null
      );
    } else if (fieldKey === 'tplCornerLabel' || fieldKey === 'tplTop10') {
      // let subKey = '';
      // showName === VARIABLES.CORNER_TITLE.AWARD
      //   ? (subKey = VARIABLES.CORNER_TYPE.AWARD.toLowerCase())
      //   : (subKey = VARIABLES.CORNER_TYPE.RECOMMEND.toLowerCase());
      // const idx = this.getSelectionIdx(items, this.corner[subKey]);
      return (
        (items && (
          <div className="dropdown-item">
            <span className="label">{showName}</span>
            {showName === VARIABLES.CORNER_TITLE.AWARD &&
              showRabbitBrandInfo() && (
                <div className="award-select">
                  <span className="icon-question">?</span>
                  <span className="tip-text">兔展设计大赛获奖模板</span>
                </div>
              )}
            <DropDown
              selected={idx || 0}
              items={items}
              onSelected={(idx, value, text) => {
                this.handleCornerSearch(type, fieldKey, value, showName, text);
              }}
            />
          </div>
        )) ||
        null
      );
    } else {
      return (
        (items && (
          <div className="dropdown-item">
            <span className="label">{showName}</span>
            <DropDown
              selected={idx || 0}
              items={items}
              onSelected={(idx, value, text) =>
                this.handleUpdateSubmitFilters.call(
                  this,
                  type,
                  showName,
                  fieldKey,
                  value,
                  text
                )
              }
            />
          </div>
        )) ||
        null
      );
    }
  };

  /**
   * 获取下拉菜单筛选项下标
   * @param   {Array}    items
   * @param   {String}   key
   * @returns {number}   idex
   */
  getSelectionIdx = (items, key) => {
    let idx = 0;
    if (items instanceof Array) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].value === key) {
          idx = i;
          break;
        }
      }
    }
    return idx;
  };

  handleUpdateSubmitFilters(type, name, key, value, text, e) {
    const { addFilter, clearFilter, isSearchType } = this.props;
    if (value !== 'ALL' && isSearchType) {
      addFilter({ type, name, key, value, text });
      // 搜索页更新地址栏筛选项
      if (isSearchType) {
        updateSearchUrlFilterData(key, {
          secondFieldKey: key,
          thirdFieldKey: value,
          type: type,
        });
      }
    } else {
      clearFilter(e, { name, key, value, text });
      updateSearchUrlFilterData(key, 'ALL');
      //clearSingleSubmitFilters(key);
    }
    this.updateSubmitFilters(type, key, value, text, e);
  }

  // 更新筛选组合条件
  updateSubmitFilters(type, key, value, text, e) {
    const { filters, clearSingleSubmitFilters, category } = this.props;
    const videoItem = this.filtersList.querySelector('.video-item');
    if (value === 'ALL') {
      clearSingleSubmitFilters(key);
    } else {
      if (
        category === 'MY_TPL' ||
        category === 'ENTERPRISE' ||
        category === 'VIP'
      ) {
        this.props.setSubmitFilters({ [key]: value });
      } else {
        // 更新筛选项
        this.props.setSubmitFilters({
          [key]: { secondFieldKey: key, thirdFieldKey: value, type },
          isUrlParam: false,
        });
      }
    }
    setTimeout(() => {
      if (this.props.submitFilters['myTplType'] === '2') {
        videoItem && (videoItem.style.display = 'none');
      } else {
        videoItem && (videoItem.style.display = 'block');
      }
    }, 10);

    // 统计筛选项点击数据
    sendStat('RP_STORE', '模版市场', '点击分类筛选项', Stat.ACTION_CLICK, {
      id: 'web_mobanmarket_filter_click',
      filter: text,
      category: STAT_PARAMS.TPL_CATEGORY[this.props.category],
    });

    pushFiboTemplateFilter({ fieldName: key, text, filtersList: filters });
    // 对于普通筛选条件，更新选中状态
    if (e) {
      const normalItem = e.target;
      const li = normalItem.parentNode;

      if (li) {
        const subFilters = Array.prototype.slice.call(
          li.parentNode.querySelectorAll('.sub-filter')
        );
        for (const subFilter of subFilters) {
          subFilter.classList.remove('active');
        }
        li.classList.add('active');
      }
    }
  }

  // 切换折叠状态
  handleFolderList = e => {
    const btn = e.currentTarget;
    const filterNode = btn.parentNode;

    if (filterNode) {
      const text = btn.querySelector('.fold-text');
      const arrow = btn.querySelector('.down-arrow');
      const isFolding = filterNode.classList.contains('folding');
      const oriH = filterNode.getAttribute('data-original-height');

      if (isFolding) {
        text.innerText = '收起';
        arrow.classList.add('rotate');
        filterNode.classList.remove('folding');
        filterNode.style.height = `${oriH}px`;
      } else {
        text.innerText = '更多';
        arrow.classList.remove('rotate');
        filterNode.classList.add('folding');
        filterNode.style.height = ONE_LINE_HEIGHT;
      }
    }
  };

  /**
   * 判断是否发生了折叠，对应是否显示折叠按钮
   * @param {string} [type='switch'] 触发类型(switch => 切换tab，resize => 改变窗口大小)
   */
  updateFolderBtn(type = 'switch') {
    if (!this.filtersList) return false;

    const subFiltersLists = this.filtersList.querySelectorAll(
      '.sub-filters-list'
    );
    for (const subFiltersList of subFiltersLists) {
      let needToFold = false;
      const subFilters = Array.prototype.slice.call(
        subFiltersList.querySelectorAll('.sub-filter')
      );

      for (const subFilter of subFilters) {
        const prevFilter = subFilter.previousSibling;
        if (prevFilter) {
          // 上一个兄弟节点的top值比现节点的小即发生了折叠
          const prevY = prevFilter.getBoundingClientRect().top;
          const currY = subFilter.getBoundingClientRect().top;

          if (prevY < currY) {
            needToFold = true;
            break;
          }
        }
      }

      const filterNode = subFiltersList.parentNode;

      // 下拉项不进行折叠
      if (
        !filterNode ||
        (filterNode && filterNode.classList.contains('selection-filter'))
      ) {
        continue;
      }

      // 更新折叠按钮状态
      const text = filterNode.querySelector('.fold-text');
      const arrow = filterNode.querySelector('.down-arrow');
      const activeFilter = filterNode.querySelector('.sub-filter.active');
      const presetH = filterNode.getAttribute('data-original-height');
      const oriH = presetH || filterNode.offsetHeight;

      // 需要折叠
      if (needToFold) {
        // 切换tab触发的折叠，默认全部收起
        if (type === 'switch') {
          filterNode.classList.add('foldable', 'folding');
          !presetH && filterNode.setAttribute('data-original-height', oriH);

          filterNode.style.height = ONE_LINE_HEIGHT;
          text.innerText = '更多';
          arrow.classList.remove('rotate');
        } else if (type === 'resize') {
          // 改变窗口大小触发的折叠(从不折叠到需要折叠)
          if (!filterNode.classList.contains('foldable')) {
            filterNode.classList.add('foldable');
            !presetH && filterNode.setAttribute('data-original-height', oriH);

            const activeH = activeFilter.offsetTop;
            const firstH = subFilters[0].offsetTop;

            // 如果选中项不在第一行，不折叠
            if (activeH !== firstH) {
              filterNode.style.height = oriH + 'px';
              text.innerText = '收起';
              arrow.classList.add('rotate');
            } else {
              // 如果选中项在第一行，折叠
              filterNode.classList.add('folding');
              filterNode.style.height = ONE_LINE_HEIGHT;
              text.innerText = '更多';
              arrow.classList.remove('rotate');
            }
          }
        }
      } else {
        // 不需要折叠
        filterNode.classList.remove('foldable', 'folding');
        filterNode.style.height = 'auto';
      }
    }
  }

  /**
   * 查询url参数点击激活对应筛选项分类
   */
  getQueryParamsFilter() {
    const queryObj = qs.parse(window.location.search) || {};
    const { filters } = queryObj;
    let filtersList;
    try {
      filtersList = JSON.parse(decodeURIComponent(filters));
      //获取url 存储的过滤条件、用来回显
      for (const [key, values] of Object.entries(filtersList)) {
        this.props.setSubmitFilters({
          [key]: values,
          isUrlParam: true,
        });
      }
    } catch (e) {
      filtersList = {};
    }
    if (!this.filtersList) return false;
    const subFiltersLists = this.filtersList.querySelectorAll(
      '.sub-filters-list'
    );
    Object.keys(filtersList).forEach(key => {
      for (const subFiltersList of subFiltersLists) {
        const subFilterItem = subFiltersList.getAttribute('data-key');
        const subFilters = Array.prototype.slice.call(
          subFiltersList.querySelectorAll('.sub-filter')
        );
        if (subFilterItem === key) {
          for (const filtersItem of subFilters) {
            const item = filtersItem.getAttribute('data-value');
            filtersItem.classList.remove('active');
            if (item === filtersList[key].thirdFieldKey) {
              // 对应筛选项设置光亮
              filtersItem.classList.add('active');
            }
          }
        }
      }
    });
  }

  render() {
    const {
      user,
      category,
      filters,
      openZoneFilters,
      setOpenSearchFilters,
      orgZoneFilters,
      setOrgZoneSearchFilters,
      orgZoneSearchFilters,
      openSearchFilters,
    } = this.props;
    const isOrgTab = category === VARIABLES.ENTERPRISE;
    // const isOrgUser = !!(user && user.organizeId);
    const isMyTplTab = category === VARIABLES.MY_TPL;
    const isLogined = !!(user && user.userId);
    const isShowNull = isMyTplTab && !isLogined;
    const isOpenZone = category === VARIABLES.OPENZONE;

    const cls =
      (!filters.length && !isOpenZone && !isOrgTab) || isShowNull
        ? 'empty'
        : '';

    return (
      <React.Fragment>
        <div className={`cmp store-filters ${cls} transitionable`}>
          {isOpenZone ? (
            <StoreFiltersOpenZone
              filters={openZoneFilters}
              setFilters={setOpenSearchFilters}
              selectedFilters={openSearchFilters}
            />
          ) : isOrgTab ? (
            <StoreFiltersOrgZone
              filters={orgZoneFilters}
              setFilters={setOrgZoneSearchFilters}
              selectedFilters={orgZoneSearchFilters}
            />
          ) : (
            <ul
              className="filters-list"
              ref={node => (this.filtersList = node)}>
              {isShowNull ? null : this.getFilters()}
            </ul>
          )}
        </div>
        <SortSwitch
          filterChange={this.props.setSubmitFilters}
          category={category}
          setMostHot={setOpenSearchFilters}
        />
      </React.Fragment>
    );
  }
}

export default StoreFilters;
